import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes,useParams  } from 'react-router-dom';

import './index.css';
import App from './App';
// import App_cn from './App_cn';
import Home from './Home';
import ErrorPage from "./error-page";
import Admin from './admin';
import Zero from './Zero';
import Bookingadmin from './Bookingadmin';
import Bookingstudent from './Bookingstudent';
import Bookingteacher from './Bookingteacher';
import Myschedule from './Studentsched';
import Adminuserlist from './Adminuserlist'
import PhonicsAa from './PhonicsAa';
import PhonicsBb from './PhonicsBb';
import PhonicsCc from './PhonicsCc';
import PhonicsDd from './PhonicsDd';
import PhonicsEe from './PhonicsEe';
import PhonicsFf from './PhonicsFf';
import PhonicsGg from './PhonicsGg';
import PhonicsHh from './PhonicsHh';
import PhonicsIi from './PhonicsIi';
import PhonicsJj from './PhonicsJj';
import PhonicsKk from './PhonicsKk';
import PhonicsMm from './PhonicsMm';
import PhonicsNn from './PhonicsNn';
import PhonicsOo from './PhonicsOo';
import PhonicsPp from './PhonicsPp';
import PhonicsQq from './PhonicsQq';
import PhonicsRr from './PhonicsRr';
import PhonicsSs from './PhonicsSs';
import PhonicsTt from './PhonicsTt';
import PhonicsUu from './PhonicsUu';
import PhonicsWw from './PhonicsWw';
import PhonicsVv from './PhonicsVv';
import PhonicsXx from './PhonicsXx';
import PhonicsYy from './PhonicsYy';
import PhonicsZz from './PhonicsZz';
import PhonicsLt01 from './PhonicsLt01';
import PhonicsLt02 from './PhonicsLt02';
import PhonicsLt03 from './PhonicsLt03';
import PhonicsLt04 from './PhonicsLt04';
import PhonicsLt05 from './PhonicsLt05';
import PhonicsLt06 from './PhonicsLt06';
import PhonicsLt07 from './PhonicsLt07';
import PhonicsLt08 from './PhonicsLt08';
import PhonicsLt09 from './PhonicsLt09';
import PhonicsLt10 from './PhonicsLt10';
import PhonicsLt11 from './PhonicsLt11';
import PhonicsLt12 from './PhonicsLt12';
import PhonicsLt13 from './PhonicsLt13';
import PhonicsLt14 from './PhonicsLt14';
import PhonicsLt15 from './PhonicsLt15';
import PhonicsLt16 from './PhonicsLt16';
import PhonicsLt17 from './PhonicsLt17';
import PhonicsLt18 from './PhonicsLt18';
import PhonicsLt19 from './PhonicsLt19';
import PhonicsLt20 from './PhonicsLt20';
import PhonicsLt21 from './PhonicsLt21';
import PhonicsLt22 from './PhonicsLt22';
import PhonicsLt23 from './PhonicsLt23';
import PhonicsLt24 from './PhonicsLt24';
import PhonicsLt25 from './PhonicsLt25';
import GoodEnglish1aL01 from './GoodEnglish1aL01';
import GoodEnglish1aL02 from './GoodEnglish1aL02';
import GoodEnglish1aL03 from './GoodEnglish1aL03';
import PhonicsLl from './PhonicsLl';
import PhonicsAaNN from './PhonicsAaNN';
import PhonicsOoYY from './PhonicsOoYY';


// import Session_messages from './session_messages';
// import reportWebVitals from './reportWebVitals';

// import {
//   createBrowserRouter,
//   RouterProvider,
// } from "react-router-dom";


const BookingComponent = () => {
  const { user_type } = useParams();

  let bookingContent;
  switch (user_type) {
    case "0": // Admin
      bookingContent = <Bookingadmin />;
      break;
    case "1": // Student
      bookingContent = <Bookingstudent />;
      break;
    case "2": // Teacher
      bookingContent = <Bookingteacher />;
      break;
    default:
      // Handle other cases or show an error message
      bookingContent = <div><ErrorPage/></div>;
  }

  return <div>{bookingContent}</div>;
};

function MyRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id/:user_name/:key/:user_type/myschedule" element={<Myschedule />} />
        <Route path="/:id/:user_name/:key/:user_type/booking" element={<BookingComponent />} />
        <Route path="/:user_id/:user_name/:user_key/:user_type/userlist" element={<Adminuserlist/>} />
        <Route path="/chat/:learnLanguage/:nativeLanguage/:chat_id/:student_id" element={<App />} />
        <Route path="/admin/:admin_key" element={<Admin />} />
        <Route path="/zerolevel/" element={<Zero />} />
        <Route path="/phonics/aa" element={<PhonicsAa />} />
        <Route path="/phonics/bb" element={<PhonicsBb />} />
        <Route path="/phonics/cc" element={<PhonicsCc />} />
        <Route path="/phonics/dd" element={<PhonicsDd />} />
        <Route path="/phonics/ee" element={<PhonicsEe />} />
        <Route path="/phonics/ff" element={<PhonicsFf />} />
        <Route path="/phonics/gg" element={<PhonicsGg />} />
        <Route path="/phonics/hh" element={<PhonicsHh />} />
        <Route path="/phonics/ii" element={<PhonicsIi />} />
        <Route path="/phonics/jj" element={<PhonicsJj />} />
        <Route path="/phonics/kk" element={<PhonicsKk />} />
        <Route path="/phonics/mm" element={<PhonicsMm />} />
        <Route path="/phonics/nn" element={<PhonicsNn />} />
        <Route path="/phonics/oo" element={<PhonicsOo />} />
        <Route path="/phonics/pp" element={<PhonicsPp />} />
        <Route path="/phonics/qq" element={<PhonicsQq />} />
        <Route path="/phonics/rr" element={<PhonicsRr />} />
        <Route path="/phonics/ss" element={<PhonicsSs />} />
        <Route path="/phonics/tt" element={<PhonicsTt />} />
        <Route path="/phonics/uu" element={<PhonicsUu />} />
        <Route path="/phonics/ww" element={<PhonicsWw />} />
        <Route path="/phonics/vv" element={<PhonicsVv />} />
        <Route path="/phonics/xx" element={<PhonicsXx />} />
        <Route path="/phonics/yy" element={<PhonicsYy />} />
        <Route path="/phonics/zz" element={<PhonicsZz />} />
        <Route path="/phonics/ll" element={<PhonicsLl />} />
        <Route path="/phonics/aa_nn" element={<PhonicsAaNN />} />
        <Route path="/phonics/oo_yy" element={<PhonicsOoYY />} />
        <Route path="/phonics/lt01" element={<PhonicsLt01 />} />
        <Route path="/phonics/lt02" element={<PhonicsLt02 />} />
        <Route path="/phonics/lt03" element={<PhonicsLt03 />} />
        <Route path="/phonics/lt04" element={<PhonicsLt04 />} />
        <Route path="/phonics/lt05" element={<PhonicsLt05 />} />
        <Route path="/phonics/lt06" element={<PhonicsLt06 />} />
        <Route path="/phonics/lt07" element={<PhonicsLt07 />} />
        <Route path="/phonics/lt08" element={<PhonicsLt08 />} />
        <Route path="/phonics/lt09" element={<PhonicsLt09 />} />
        <Route path="/phonics/lt10" element={<PhonicsLt10 />} />
        <Route path="/phonics/lt11" element={<PhonicsLt11 />} />
        <Route path="/phonics/lt12" element={<PhonicsLt12 />} />
        <Route path="/phonics/lt13" element={<PhonicsLt13 />} />
        <Route path="/phonics/lt14" element={<PhonicsLt14 />} />
        <Route path="/phonics/lt15" element={<PhonicsLt15 />} />
        <Route path="/phonics/lt16" element={<PhonicsLt16 />} />
        <Route path="/phonics/lt17" element={<PhonicsLt17 />} />
        <Route path="/phonics/lt18" element={<PhonicsLt18 />} />
        <Route path="/phonics/lt19" element={<PhonicsLt19 />} />
        <Route path="/phonics/lt20" element={<PhonicsLt20 />} />
        <Route path="/phonics/lt21" element={<PhonicsLt21 />} />
        <Route path="/phonics/lt22" element={<PhonicsLt22 />} />
        <Route path="/phonics/lt23" element={<PhonicsLt23 />} />
        <Route path="/phonics/lt24" element={<PhonicsLt24 />} />
        <Route path="/phonics/lt25" element={<PhonicsLt25 />} />
        <Route path="/ge/1a/l01" element={<GoodEnglish1aL01 />} />
        <Route path="/ge/1a/l02" element={<GoodEnglish1aL02 />} />
        <Route path="/ge/1a/l03" element={<GoodEnglish1aL03 />} />

        {/* <Route path="/session_messages/:session_id/:chat_id" element={<Session_messages />} /> */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//     errorElement: <ErrorPage />,
//   },
//   {
//     path: "chat_a0451x",
//     element: <App />,
//   },
//   {
//     path: "chat_x0571d",
//     element: <App />,
//   },
// ]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <MyRouter />
  // </React.StrictMode>
);


